export const DISPLAY_ADD_FUNDS_ALERT_FLAG = 'display-add-funds-alert'
export const DISPLAY_DASHBOARD_ALERT_FLAG = 'display-dashboard-alert'
export const DISPLAY_SEND_ALERT_FLAG = 'display-send-alert'
export const ENABLE_PURCHASE_BILLPAY = 'enable-purchase-billpay'
export const ENABLE_PURCHASE_FLOW = 'enable-purchase-flow'
export const DISPLAY_SIGN_UP_FLAG = 'display-sign-up'
export const DISPLAY_BILL_PAY_FLAG = 'display-bill-pay'
